module.exports = __webpack_public_path__ + "img/enemy_111_002.45f0c985.png";